import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { ClientePipeSharedModule } from '../../pipes';
import { ClienteAnaliseFinanceiraFormModule } from '../form';

import { ClienteAnaliseFinanceiraConcluirModalComponent } from './cliente-analise-financeira-concluir-modal.component';

@NgModule({
    imports: [
        SharedModule,
        ClientePipeSharedModule,
        ClienteAnaliseFinanceiraFormModule
    ],
    declarations: [
        ClienteAnaliseFinanceiraConcluirModalComponent
    ],
    exports: [
        ClienteAnaliseFinanceiraConcluirModalComponent
    ]
})
export class ClienteAnaliseFinanceiraConcluirModule { }
